function createManagementStore({
  Framework,
  StoreLibrary,
  state,
  mutations,
  actions,
  storage,
}) {
  Framework.use(StoreLibrary);

  const store = new StoreLibrary.Store({
    state,
    mutations,
    actions,
  });

  const token = storage.getItem('accesstoken');
  if (token) store.commit('LOGIN', token);

  return store;
}

module.exports = createManagementStore;
